<template>
  <div class="tabel">
    <div class="project_index_main"     v-loading="loading">
      <!-- 申报内容 -->
      <div class="project_table_list" id="pdfs">
        <!-- 项目登记号 -->
        <div class="project_table_item">
          <div class="project_code_box">
            <table border="1" cellspacing="0">
              <tr>
                <td colspan="1">
                  项目登记号
                </td>
                <td colspan="2" style="width: 150px"></td>
              </tr>
            </table>
          </div>
          <div class="project_header_box">
            <h1 class="tc">
              北京市社会组织服务项目申报书
            </h1>
            <table border="0" cellspacing="0" class="project_header_table">
              <tr class="project_header_item">
                <td colspan="1">
                  项目方向：
                </td>
                <td colspan="2">
                  {{ ruleForm.project_class | directionOneFormat }} -
                  {{ ruleForm.project_direction | directionTwoFormat }}
                </td>
              </tr>
              <tr class="project_header_item">
                <td colspan="1">
                  项目名称：
                </td>
                <td colspan="2">{{ ruleForm.project_name }}</td>
              </tr>
              <tr class="project_header_item">
                <td colspan="1">
                  申报单位：
                </td>
                <td colspan="2">{{ user.organ_name }}</td>
              </tr>
              <tr class="project_header_item">
                <td colspan="1">
                  实 施 地：
                </td>
                <td colspan="2">
                  {{ ruleForm.province_id | provinceclassFormat }}{{ ruleForm.city_id | cityclassFormat }}{{ ruleForm.land_area }}
                </td>
              </tr>
              <tr class="project_header_item">
                <td colspan="1">
                  申报日期：
                </td>
                <td colspan="2">
                  {{ruleForm.create_time ?  zhDate(new Date(ruleForm.create_time) * 1000, 6) : zhDate(new Date().getTime(), 6) }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 基本情况 -->
        <div class="project_table_item index_page">
          <h2 class="project_table_item_title">一、基本情况</h2>

          <table border="1" cellspacing="0">
            <tr>
              <td colspan="1">项目名称</td>
              <td colspan="5  ">{{ ruleForm.project_name }}</td>
            </tr>
            <tr>
              <td colspan="1">申报单位</td>
              <td colspan="5">{{ user.organ_name }}</td>
            </tr>
            <tr>
              <td colspan="1">项目方向</td>
              <td colspan="5">{{ ruleForm.project_class | directionOneFormat }} -
                {{ ruleForm.project_direction | directionTwoFormat }}
              </td>
            </tr>
            <tr>
              <!--<td colspan="1">项目服务领域</td>
              <td colspan="2">IT互联网领域</td>-->
              <td colspan="1">实施地</td>
              <td colspan="5">
                {{ ruleForm.province_id | provinceclassFormat }}{{ ruleForm.city_id | cityclassFormat }}{{ ruleForm.land_area }}
              </td>
            </tr>
            <tr>
              <td colspan="1">申报单位属性</td>
              <td colspan="5">{{ ruleForm.organ_class | orgclassFormat }}</td>
            </tr>
            <tr>
              <td colspan="1">通讯地址</td>
              <td colspan="2">{{ ruleForm.mail_address }}</td>
              <td colspan="1">邮政编码</td>
              <td colspan="2">{{ ruleForm.post_code }}</td>
            </tr>
            <tr>
              <td colspan="1">电子信箱</td>
              <td colspan="2">{{ ruleForm.email }}</td>
              <td colspan="1">传真电话</td>
              <td colspan="2">{{ ruleForm.fax_phone }}</td>
            </tr>
            <tr>
              <td colspan="1">法定代表人</td>
              <td colspan="2">{{ ruleForm.legal_person }}</td>
              <td colspan="1">法人代码</td>
              <td colspan="2">{{ ruleForm.corporate_code }}</td>
            </tr>
            <tr>
              <td colspan="1" class="empty_line_box">
                        <span class="empty_line">

                        </span>
              </td>
              <td colspan="1">姓名</td>
              <td colspan="1">职务</td>
              <td colspan="2">办公电话</td>
              <td colspan="1">手机</td>
            </tr>
            <tr>
              <td colspan="1">项目负责人</td>
              <td colspan="1">{{ ruleForm.charge_name }}</td>
              <td colspan="1">{{ ruleForm.charge_job }}</td>
              <td colspan="2">{{ ruleForm.charge_tel }}</td>
              <td colspan="1">{{ ruleForm.charge_phone }}</td>
            </tr>
            <tr>
              <td colspan="1">项目联系人</td>
              <td colspan="1">{{ ruleForm.contact_name }}</td>
              <td colspan="1">{{ ruleForm.contact_job }}</td>
              <td colspan="2">{{ ruleForm.contact_tel }}</td>
              <td colspan="1">{{ ruleForm.contact_phone }}</td>
            </tr>
            <tr>
              <td colspan="1">实施地单位</td>
              <td colspan="5">{{ ruleForm.implement_organ_name }}</td>
            </tr>
            <tr>
              <td colspan="1">通讯地址</td>
              <td colspan="2">{{ ruleForm.implement_mail_address }}</td>
              <td colspan="2">邮政编码</td>
              <td colspan="1">{{ ruleForm.implement_post_code }}</td>
            </tr>
            <tr>
              <td colspan="1">电子信箱</td>
              <td colspan="2">{{ ruleForm.implement_email }}</td>
              <td colspan="2">传真电话</td>
              <td colspan="1">{{ ruleForm.implement_fax_phone }}</td>
            </tr>
            <tr>
              <td colspan="1" class="empty_line_box">
                        <span class="empty_line">

                        </span>
              </td>
              <td colspan="1">姓名</td>
              <td colspan="1">职务</td>
              <td colspan="2">办公电话</td>
              <td colspan="1">手机</td>
            </tr>
            <tr>
              <td colspan="1">实施地负责人</td>
              <td colspan="1">{{ ruleForm.implement_charge_name }}</td>
              <td colspan="1">{{ ruleForm.implement_charge_job }}</td>
              <td colspan="2">{{ ruleForm.implement_charge_tel }}</td>
              <td colspan="1">{{ ruleForm.implement_charge_phone }}</td>
            </tr>
            <tr>
              <td colspan="1">实施地联系人</td>
              <td colspan="1">{{ ruleForm.implement_contact_name }}</td>
              <td colspan="1">{{ ruleForm.implement_contact_job }}</td>
              <td colspan="2">{{ ruleForm.implement_contact_tel }}</td>
              <td colspan="1">{{ ruleForm.implement_contact_phone }}</td>
            </tr>
          </table>
        </div>
        <!--  -->
        <div class="project_table_item index_page">
          <!-- 申报单位简介 -->
          <h2 class="project_table_item_title">二、申报单位简介（200 字以内）</h2>

          <table border="1" cellspacing="0">
            <tr>
              <td class="project_text" v-html="ruleForm.organ_introduce"></td>
            </tr>
          </table>

          <!-- 项目简介 -->
          <h2 class="project_table_item_title">三、项目简介（200 字以内）</h2>

          <table border="1" cellspacing="0">
            <tr>
              <td class="project_text" v-html="ruleForm.project_introduce"></td>
            </tr>
          </table>
        </div>
        <!--  -->
        <div class="project_table_item index_page">
          <!-- 项目论证 -->
          <h2 class="project_table_item_title">四、项目论证</h2>

          <table border="1" cellspacing="0">
            <tr>
              <td>
                一、项目实施的必要性、可行性
              </td>
            </tr>
            <tr>
              <td class="project_text" v-html="ruleForm.project_assessment[0].value"></td>
            </tr>
            <tr>
              <td>
                二、项目实施的已有基础、具体方法和途径及进度安排、预期效果及完成时间
              </td>
            </tr>
            <tr>
              <td class="project_text" v-html="ruleForm.project_assessment[1].value"></td>
            </tr>
            <tr>
              <td>
                三、项目实施涵盖的范围、实施的规模、服务的人群、创新之举等
              </td>
            </tr>
            <tr>
              <td class="project_text" v-html="ruleForm.project_assessment[2].value"></td>
            </tr>
            <tr>
              <td>
                四、其他
              </td>
            </tr>
            <tr>
              <td class="project_text" v-html="ruleForm.project_assessment[3].value"></td>
            </tr>
          </table>
        </div>
        <!-- 经费预算 -->
        <div class="project_table_item index_page">
          <h2 class="project_table_item_title">五、经费预算</h2>

          <table border="1" cellspacing="0">
            <tr>
              <td colspan="3" class="tc">资金预算</td>
              <td colspan="5" class="tr">
                {{ ruleForm.funding_budget }}（元）
              </td>
            </tr>
            <tr>
              <td colspan="3" class="tc">其中：可自筹资金数额（比例）</td>
              <td colspan="5" class="tr">
                <div>
                  {{ ruleForm.self_account }}（元）
                </div>
                <div style="margin-top: 20px;">
                  {{ ruleForm.self_percent }}%
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="tc">其中：需支持的资金数额（比例）</td>
              <td colspan="5" class="tr">
                <div>
                  {{ ruleForm.support_account }}（元）
                </div>
                <div style="margin-top: 20px;">
                  {{ ruleForm.support_percent }}%
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="7" class="tc">项目经费支出明细</td>
            </tr>
            <tr class="tc" style="height: 80px;">
              <td colspan="1" style="width: 45px;" class="tc">序<br/>号</td>
              <td colspan="1">费用类别</td>
              <td colspan="1">单价（元）</td>
              <td colspan="1">标准</td>
              <td colspan="1">数量</td>
              <td colspan="1">资金金额（元）</td>
              <td colspan="1">备注</td>
            </tr>
            <tr class="tc" v-for="(item , index) in ruleForm.account_record" :key="index">
              <td colspan="1" style="width: 45px;" class="tc">{{ (index + 1) }}</td>
              <td colspan="1">{{ item.type }}</td>
              <td colspan="1">{{ item.price }}</td>
              <td colspan="1">{{ item.unit }}</td>
              <td colspan="1">{{ item.number }}</td>
              <td colspan="1">{{ item.total_price }}</td>
              <td colspan="1">{{ item.remark }}</td>
            </tr>
            <tr class="tc">
              <td colspan="5">合计</td>
              <!--              <td colspan="1">1</td>-->
              <td colspan="2">{{ ruleForm.total_account }}</td>
            </tr>
          </table>
        </div>
        <!--  -->
        <div class="project_table_item">
          <!-- 申报单位承诺 -->
          <h2 class="project_table_item_title">六、申报单位承诺</h2>
          <table border="1" cellspacing="0" style="min-height: 350px;letter-spacing: 1px;">
            <tr style="height: 150px;line-height: 150px;border-bottom: none;">
              <td colspan="2" class="tc" style="height: 150px;line-height: 150px;border-bottom: none;">
                <h3 style="font-weight: normal;">
                  我们确认项目申报内容的真实性，并愿意承担相应的责任。
                </h3>
              </td>
            </tr>
            <tr style="height: 100px;line-height: 100px;border-top: none;border-bottom: none;">
              <td colspan="1" class="tc"
                  style="height: 100px;line-height: 100px;border-top: none;border-right: none;border-bottom: none">
                <h4 style="font-weight: normal">负责人签字：</h4>
              </td>
              <td colspan="1" class="tc"
                  style="height: 100px;line-height: 100px;border-top: none;border-left: none;border-bottom: none;">
                <h4 style="font-weight: normal">申报单位盖章：</h4>
              </td>
            </tr>
            <tr style="border-top: none;">
              <td colspan="2" class="tr" style="border-top: none;">
                年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
              </td>
            </tr>
          </table>

          <!-- 项目实施地单位意见 -->
          <h2 class="project_table_item_title">七、项目实施地单位意见（街、乡、区级委办局等）</h2>

          <table border="1" cellspacing="0" style="min-height: 350px;letter-spacing: 1px;">
            <tr style="height: 100px;line-height: 100px;border-bottom: none;">
              <td colspan="2" class="tc" style="height: 100px;line-height: 100px;border-bottom: none;">

              </td>
            </tr>
            <tr style="height: 150px;line-height: 150px;border-top: none;border-bottom: none;">
              <td colspan="1" class="tc"
                  style="height: 150px;line-height: 150px;border-top: none;border-right: none;border-bottom: none">
                <h4 style="font-weight: normal">负责人签字：</h4>
              </td>
              <td colspan="1" class="tc"
                  style="height: 150px;line-height: 150px;border-top: none;border-left: none;border-bottom: none;">
                <h4 style="font-weight: normal">申报单位盖章：</h4>
              </td>
            </tr>
            <tr style="border-top: none;">
              <td colspan="2" class="tr" style="border-top: none;">
                年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
              </td>
            </tr>
          </table>
        </div>

      </div>
    </div>

   <div style="width: 100%;display: flex;justify-content: center;padding: 50px">
     <el-button  style="width: 150px;height: 60px;font-size: 16px;" type="primary" :loading="loading" @click="install('pdfs',ruleForm.project_name)">导出</el-button>
   </div>

  </div>
</template>
<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {
  cityList,
  getOrganClassList,
  getProjectApplicationDetail,
  getProjectClassLevelList,
  getProjectClassList
} from "@/api";
import {find2CN, zhDate} from "@/tools";

let that;
export default {
  name: "tabel",
  beforeCreate() {
    that = this;
  },
  data() {
    return {
      id:'',
      zhDate: zhDate,
      loading:false,
      directionOne: [], // 项目方向1options
      directionTwo: [], // 项目方向2options
      orgclass: [],     // 申报单位属性options
      provinceclass: [],     // 项目落地区域省options
      cityclass: [],     // 项目落地区域省市options
      ruleForm: {
        project_name: '',         // 项目名称
        project_class: '',        // 项目方向1
        project_direction: '',    // 项目方向2
        organ_class: '',          // 申报单位属性
        province_id: '',          // 实施地省
        city_id: '',              // 实施地市
        land_area: '',            // 实施地区
        mail_address: '',            // 通讯地址
        post_code: '',            // 邮政编码
        email: '',            // 电子信箱
        fax_phone: '',            // 传真电话
        legal_person: '',            // 法定代表人
        corporate_code: '',            // 法人代码
        charge_name: '',            // 负责人姓名
        charge_job: '',            // 负责人职务
        charge_tel: '',            // 负责人电话
        charge_phone: '',            // 负责人手机
        contact_name: '',            // 联系人姓名
        contact_job: '',            // 联系人职务
        contact_tel: '',            // 联系人电话
        contact_phone: '',            // 联系人手机
        implement_organ_name: '',            // 实施地单位
        implement_mail_address: '',            // 实施地 通讯地址
        implement_post_code: '',            // 实施地 邮政编码
        implement_email: '',            // 实施地 电子信箱
        implement_fax_phone: '',            // 实施地 传真电话
        implement_charge_name: '',            // 实施地 负责人姓名
        implement_charge_job: '',            // 实施地 负责人职务
        implement_charge_tel: '',            // 实施地 负责人电话
        implement_charge_phone: '',            // 实施地 负责人手机
        implement_contact_name: '',            // 实施地 联系人姓名
        implement_contact_job: '',            // 实施地 联系人职务
        implement_contact_tel: '',            // 实施地 联系人电话
        implement_contact_phone: '',            // 实施地 联系人手机
        organ_introduce: '',            // 申报单位简介
        project_introduce: '',            // 项目简介
        project_assessment: [  // 项目论证
          {
            type: 'textarea',
            placeholder: '请输入',
            title: '（一）项目实施的必要性、可行性',
            value: '',
            id: 1
          },
          {
            type: 'textarea',
            placeholder: '1、项目实施的已有基础〔说明：包括但不限于项目实施已有的相关经验或有助于项目实施的资源支持等。）' +
              '2、具体方法和途径〔说明：包括项目实施的具体方式、途径。明确项目的具体组成内容，每类、每次活动的具体内容、形式、对象、次数、人数等。〕' +
              '3、进度安排〔说明：建议时间单元为月，不建议简单表述为“年内”、“上半年”、“下半年”、“第*季度”等。〕' +
              '4、预期效果〔说明：具体明确项目实施所要达到的目标或预期的效果。〕' +
              '5、项目团队及分工〔说明：包括项目实施的组织管理机构组成，各有关协作单位等。如以街道社区社会组织联合会名义申报社区社会组织承接的项目，要细化项目的组织实施体系。如有涉及到委托管理（如财务委托管理）的，要在组织架构中予以说明。要把可能引起转包嫌疑的所有事项交代清楚，避免在检查、审计和评估中产生误解。〕',
            title: '（二）项目实施的已有基础、具体方法和途径及进度安排、预期效果及完成时间',
            value: '',
            id: 2
          },
          {
            type: 'textarea',
            placeholder: '请输入',
            title: '（三）项目实施涵盖的范围、实施的规模、服务的人群、创新之处等',
            value: '',
            id: 3
          },
          {
            type: 'textarea',
            placeholder: '请输入',
            title: '（四）其他',
            value: '',
            id: 4
          },
        ],
        funding_budget: '',     // 资金预算
        self_account: '',     // 可自筹资金数额元
        self_percent: '',     // 可自筹资金数额%
        support_account: '',     // 需支持的资金数额元
        support_percent: '',     // 需支持的资金数额%
        account_record: [
          // {
          //   type:'类别',
          //   price:1.00,
          //   number:2,
          //   remark:'',
          //   total_price:300.00,
          // },
        ],
        total_account: '',    //项目经费支出明细合计金额
        other_file: [],
        is_agree: 0,
        checkedother: false,

      }
    }
  },
  components: {},
  computed: {
    token() {
      return this.$store.state.shzztoken
    },
    user() {
      return this.$store.state.shzzuser
    },
  },
  created() {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {

    async detailInfo() {
      let _data = await getProjectApplicationDetail(
        this.id
      )
      if (_data.code == 200) {
        this.ruleForm = _data.data
        this.ruleForm.other_file = JSON.parse(this.ruleForm.other_file)
        this.child()
        this.cityList()
      } else {
        this.$message.error(_data.message)
      }
    },

    async install(name, title) {
      this.loading = true
      const ele = document.querySelector('#' + name)
      const eleW = ele.offsetWidth// 获得该容器的宽
      const eleH = ele.offsetHeight// 获得该容器的高

      const eleOffsetTop = ele.offsetTop // 获得该容器到文档顶部的距离
      const eleOffsetLeft = ele.offsetLeft // 获得该容器到文档最左的距离

      var canvas = document.createElement('canvas')
      var abs = 0

      const win_in = document.documentElement.clientWidth || document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
      const win_out = window.innerWidth // 获得当前窗口的宽度（包含滚动条）

      if (win_out > win_in) {
        // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        abs = (win_out - win_in) / 2 // 获得滚动条宽度的一半
        // console.log(a, '新abs');
      }

      canvas.width = eleW * 2 // 将画布宽&&高放大两倍
      canvas.height = eleH * 2

      var context = canvas.getContext('2d')

      context.scale(2, 2)

      context.translate(-eleOffsetLeft - abs, -eleOffsetTop)
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉

      var pdf = new jsPDF('', 'pt', 'a4')
      const childrenBox = ele.children
      for (let i = 0; i < childrenBox.length; i++) { // 循环传过来的Dom的字节点 每个子节点打印成一页pdf A4纸那么大
        const res = await html2canvas(childrenBox[i], {
          dpi: 300,
          // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
          useCORS: true, // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
          scale: 4, // 提升导出的文件的分辨率
        })
        var pageData = res.toDataURL('image/jpeg', 1.0)
        var contentWidth = res.width
        var contentHeight = res.height
        var imgWidth = 555.28
        var imgHeight = 552.28 / contentWidth * contentHeight
        // pdf.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight)
        var positionss = 0
        var leftHeight = contentHeight

        // var pageHeight = (contentWidth / 592.28 * 841.89) - 20
        var pageHeight = imgWidth * canvas.height / canvas.width;
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 20, positionss, imgWidth, imgHeight)
            leftHeight -= pageHeight
            // positionss -= 841.89
            positionss -= 841.89
            console.log(leftHeight)
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }
        if (i < childrenBox.length - 1) {
          pdf.addPage() // 避免最后多一个空白页
        }
      }
      pdf.save(`${title.trim()}申报书.pdf`);
      this.loading = false
    },

    async init() {
      if(this.id) {
        let _data = await getProjectApplicationDetail(
          this.id
        )
        if (_data.code == 200) {
          this.ruleForm = _data.data
        } else {
          this.$message.error(_data.message)
        }
      }else {
        this.ruleForm = JSON.parse(localStorage.getItem('formStr'))
      }
      // 申报单位属性列表
      let res = await getOrganClassList()
      if (res.code == 200) {
        this.orgclass = res.data
        this.orgclass.map(item => {
          item.label = item.name
        })
      }
      // 项目方向列表
      let _data = await getProjectClassList()
      this.directionOne = _data.data
      this.directionOne.map(item => {
        item.label = item.class_name
        item.value = item.id
      })
      // 城市列表
      let _info = await cityList()
      this.provinceclass = _info.data
      this.provinceclass.map(item => {
        item.label = item.name
        item.value = item.id
      })




      let _e = await getProjectClassLevelList(this.ruleForm.project_class)
      this.directionTwo = _e.data
      this.directionTwo.map(item => {
        item.label = item.class_name
        item.value = item.id
      })

      let _n = await cityList(this.ruleForm.province_id)
      this.cityclass = _n.data
      this.cityclass.map(item => {
        item.label = item.name
        item.value = item.id
      })
    },

  },
  watch: {},
  filters: {
    directionOneFormat(val) {
      return find2CN(val, that.directionOne)
    },
    directionTwoFormat(val) {
      return find2CN(val, that.directionTwo)
    },
    orgclassFormat(val) {
      return find2CN(val, that.orgclass)
    },
    provinceclassFormat(val) {
      return find2CN(val, that.provinceclass)
    },
    cityclassFormat(val) {
      return find2CN(val, that.cityclass)
    },
  }
}
</script>

<style scoped lang="scss">
.tabel {
  .bg {
    width: 170px;
    height: 60px;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    letter-spacing: 2px;
    color: #ffffff;
    cursor: pointer;
    background-image: linear-gradient(90deg,
      #0115a6 0%,
      #1546c5 100%);
    margin: 0 20px;
  }
  .project_index_main {
    width: 840px;
    padding: 20px;
    margin: 0px auto;
  }

  table {
    width: 100%;
    border-top: 1px solid black;
    border-left: 1px solid black;
  }

  table tr {
    height: 60px;
  }

  table td {
    padding: 10px;
    font-size: 16px;
    font-weight: normal;
    border-top: 1px solid black;
    border-left: 1px solid black;
    font-family: fangsong;
    min-width: 50px;
    //position: relative;
  }

  //.empty_line_box {
  //  position: relative;
  //  overflow: hidden;
  //}

  //.empty_line {
  //  position: absolute;
  //  width: 110%;
  //  height: 2px; /*这里需要自己调整，根据td的宽度和高度*/
  //  top: calc(50%);
  //  left: -5%;
  //  background-color: black;
  //  display: block;
  //  transform: rotate(19deg); /*这里需要自己调整，根据线的位置*/
  //  transform-origin: top;
  //}

  .index_page {
    page-break-after: always;
  }

  .project_table_item_title {
    line-height: 80px;
  }

  .project_text {
    line-height: 38px;
    letter-spacing: 1px;
    text-align: justify;
  }

  .tr {
    text-align: right;
  }

  .tc {
    text-align: center;
  }

  .project_code_box {
    width: 300px;
    //height: 10vh;
  }

  .project_page_box {
    width: 100%;
    //height: 100vh;
    //position: relative;
  }

  .project_header_box {
    //height: 90vh;
  }

  .project_header_box h1 {
    letter-spacing: 2px;
    margin-top: 200px;
    margin-bottom: 180px;
  }

  .project_header_table {
    width: 65%;
    margin: 0 auto;
    border: none;
  }

  .project_header_box, .project_header_item {
    width: 100%;
  }

  .project_header_item td, .project_header_item tr {
    border: none;
    font-size: 18px !important;
    height: 60px;
    line-height: 60px;
    margin: 10px 0;
  }

  .project_header_item td:nth-child(1) {
    width: 110px;
  }

  .project_header_item td:nth-child(2) {
    border-bottom: 2px solid black;
    /*min-width: 320px;*/
    text-align: center;
  }
}
</style>


